<template>
  <div class="userContact-list-content">
    <div v-show="tableData.length === 0 && dataResponse">
      <div class="row-one">
        <i class="icon icon-authTip"></i>
        <span v-html="topText" class="topText"></span>
      </div>
      <div class="no-userContact-btn">欢迎使用用户联合。<i @click="addCount">去创建</i></div>
    </div>
    <div class="name">
      {{ moduleTitle }}
    </div>
    <div class="btns" v-show="tableData.length > 0 && dataResponse">
      <div>
        <el-button
          type="primary"
          size="small"
          class="addCount"
          @click="addCount"
        >
          新建
        </el-button>
      </div>
    </div>

    <el-table class="usercontact-el-table" :data="tableData" v-show="tableData.length > 0" tooltip-effect="light" style="width: 100%">
      <el-table-column
        label="显示名称"
        prop="name"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="类型"
        prop="type"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="enable"
        label="启用状态"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.enable"
            @change="enableChange(scope.row.enable, scope.row.id)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="优先级"
        prop="priority"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        width="200px"
        align="center"
        class-name="options td-pt1"
      >
        <template slot-scope="scope">
          <span class="textBtn" @click="handleDetail(scope.row.id)">
            详情
          </span>
          <span
            class="textBtn delete"
            @click="handleDelete(scope.row.id)"
            v-if="scope.row.accountName !== 'admin'"
          >
            删除
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="tableData.length > 0"
      background
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :total="total"
      :current-page.sync="pageNum"
      @current-change="pageChange"
    >
    </el-pagination>
    <el-dialog
      :title="tipTitle"
      width="500px"
      :visible.sync="dialogRemoveOrAnable"
    >
      <div class="deleteText">
        {{ tipText }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemoveOrAnable"
          >确 定</el-button
        >
        <el-button @click="dialogRemoveOrAnable = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"
import ContactAPIS from "@/apis/userContact.js"
const { mapState, mapMutations } = createNamespacedHelpers("userManage")
export default {
  data() {
    return {
      moduleTitle: "用户联合",
      dialogRemoveOrAnable: false,
      currentFlag: "delete",
      tableData: [],
      dataResponse: false,
      breadcrumb: [
        {
          label: "用户联合"
        }
      ],
      topText:'IDaaS支持联合外部用户数据库，目前支持LDAP和Active Directory，最多可联合5个。',
      pageSize: 10,
      pageNum: 1,
      total: 0,
      realmName: this.$realm,
      currentAccountId: ""
      // searchValue: ""
    }
  },
  computed: {
    tipText() {
      return this.currentFlag === "delete"
        ? "确认删除这个用户联合吗？"
        : this.currentFlag === "enable"
        ? "确认启用这个用户联合吗？"
        : "确认禁用这个用户联合吗？"
    },
    tipTitle() {
      return this.currentFlag === "delete"
        ? "删除提示"
        : this.currentFlag === "enable"
        ? "启用提示"
        : "禁用提示"
    },
    ...mapState(["keyword"])
  },
  mounted() {
    this.getUsersList()
  },
  methods: {
    ...mapMutations(["UPDATE_KEYWORD"]),
    // 查询账户列表
    async getUsersList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      let { status, data } = await ContactAPIS.getRealmsUsersContact(this.realmName, {
        params
      })
      if (status === 0) {
        this.dataResponse = true
        this.total = data.totalCount || 0
        if (data && data.data) {
          this.tableData = data.data.map((item, index) => {
            return {
              index: index,
              name: item.name,
              type: item.type,
              enable: item.enabled === 'true' ? true:false,
              priority: item.priority,
              id: item.id
            }
          })
        }
      }
    },
    // 删除账户
    async deleteUser() {
      let { status } = await ContactAPIS.deleteUserContactById(
        this.realmName,
        this.currentAccountId
      )
      this.dialogRemoveOrAnable = false
      if (status === 0) {
        if (this.total === 1) {
          this.pageNum = 1
        } else if ((this.total - 1) % this.pageSize === 0) {
          this.pageNum -= 1
        }
        this.getUsersList()
      }
    },
    // 更新账户的启用、禁用状态
    async updateAccountInfor() {
      let currentAccount = this.tableData.find(
        item => item.id === this.currentAccountId
      )
      if (currentAccount && currentAccount.enable !== undefined) {
        let params = {
          enabled: !currentAccount.enable
        }
        let { status } = await ContactAPIS.putRealmsUserContact(
          this.realmName,
          this.currentAccountId,
          { data: params }
        )
        this.dialogRemoveOrAnable = false
        if (status === 0) {
          currentAccount.enable = !currentAccount.enable
        }
      }
    },
    // 翻页
    pageChange() {
      this.getUsersList()
    },
    // 添加账户
    addCount() {
      this.$router.push("/userContact/addUserContact")
    },
    handleDetail(id) {
      this.$router.push({
        path: "/userContact/detailUserContact",
        query: {
          accountId: id
        }
      })
    },
    // 打开删除账户弹窗
    handleDelete(id) {
      this.currentFlag = "delete"
      this.currentAccountId = id
      this.dialogRemoveOrAnable = true
    },
    // 启用状态改变，打开提示确认弹窗
    enableChange(enable, id) {
      this.currentFlag = !enable ? "enable" : ""
      this.dialogRemoveOrAnable = true
      this.currentAccountId = id
    },
    // 提交删除、启用、禁用状态
    submitRemoveOrAnable() {
      if (this.currentFlag === "delete") {
        this.deleteUser()
      } else {
        this.updateAccountInfor()
      }
    }
  }
}
</script>

<style lang="scss">
.userContact-list-content {
  .row-one {
    height: 50px;
    padding: 0 15px;
    font-size: 14px;
    background-color: rgba(0, 112, 204, 0.05);
    display: flex;
    align-items: center;
    color: #333333;
    .reUpload {
      color: #4497ec;
    }
    .icon-authTip{
      width: 35px;
      height: 35px;
    }
    .topText {
      margin-left:20px;
      i {
        font-style: normal;
        color: #4497ec;
        &.error {
          color: #d9001b;
        }
      }
    }
  }
  .el-alert{
    background:#f5f5f5 ;
    color:#454647;
    margin-bottom: 30px;
  }
  .no-userContact-btn{
    position: absolute;
    top:50%;
    font-weight: 500;
    font-size: 16px;
    left:50%;
    margin:-100px 0 0 -100px;
    i{
      border-bottom: 1px solid #4497ec;
      font-style: normal;
      color:#4497ec;
      cursor: pointer;
    }
  }
  .name {
    display: none; //暂时隐藏
  }
  .btns {
    margin: 0 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .searchBox {
      display: inline-flex;
      .iconBox {
        width: 30px;
        background-color: rgba(22, 155, 213, 1);
        flex-shrink: 0;
        text-align: center;
        line-height: 26px;
        cursor: pointer;
      }
    }
  }
  .el-dialog {
    &__title {
      color: #333333;
      font-weight: 600;
    }
    &__body {
      // padding: 0 50px;
      .deleteText {
        text-align: center;
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
</style>
